import { IoPlayOutline } from 'react-icons/io5'
import { vccBtn } from '@shared/ui/vccButtons'
import { vccButtonLabel, type VccActionButtonProps } from './vccButtonProps'

export type ExecuteButtonProps = VccActionButtonProps

export default function ExecuteButton({
  onClick,
  disabled,
  type = 'button',
  className = '',
  showIcon = true,
  loading = false,
  loadingLabel = 'Loading...',
  label = 'Execute',
  children,
  ...rest
}: ExecuteButtonProps) {
  return (
    <button
      type={type}
      className={`${vccBtn('execute')} ${className}`.trim()}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {showIcon && !loading && <IoPlayOutline aria-hidden className="vcc-btn__icon" />}
      {vccButtonLabel({ children, label, loading, loadingLabel }, label)}
    </button>
  )
}
